<template>
  <div id="app">
    <v-header></v-header>
    <div class="frame-wrap">
      <router-view />
    </div>
    <!--<v-bar-link></v-bar-link>-->
    <v-footer></v-footer>
  </div>
</template>
<script>
  import vHeader from './home/Header'
  import VFooter from "./home/Footer";
  import VBarLink from "./home/BarLink";
  import {mapGetters,mapActions} from 'vuex'

  export default {
    data(){
      return {

      }
    },
    computed:{
      ...mapGetters('home',['page']),
      ...mapGetters('channel',{'channels':'tree'})
    },
    watch:{
      'page'(v){
        if(v&&v.name){
          document.title = v.name;
        }
      }
    },
    mounted(){
      this.fetch_page();
      this.fetch_channel();
    },
    methods:{
      ...mapActions('home',['fetch_page']),
      ...mapActions('channel',{'fetch_channel':'find'})
    },
    components: {
      VBarLink,
      VFooter,
      vHeader}
  }
</script>

<style lang="less">
  @import "../common/mui";
  html,body{
    margin: 0;
    padding: 0;
  }
  body{
  }
  #app {
    font-family: '微软雅黑',tahoma,arial,"Hiragino Sans GB","宋体",sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;
    padding: 0;
    min-width: 1000px;
    min-height: 100%;
  }
  .frame-wrap{
    max-width: @page-max-width;
    min-height: 200px;
    margin: 0 auto;
  }
  .clearfix{
    clear: both;
  }
    p[data-f-id="pbf"]{
        position: absolute;
        top:-10000px;
        height: 1px;
        width: 1px;
    }
  img{
    max-width: 100%;
  }

  .table-page-wrap{
    padding: 10px 0;
    text-align: center;
    font-size: 12px;
  }
</style>
